import PropTypes from "prop-types";
import React from "react";

import { SelectFormField } from "@swa-ui/form";
import i18n from "@swa-ui/locale";
import {
  DateOfBirthFormField,
  dateOfBirthFormFieldPropTypes,
  GenderFormField,
  genderFormFieldPropTypes,
  NameFormFields,
  nameFormFieldsPropTypes,
} from "@swa-ui/personal-info";
import { classNames } from "@swa-ui/string";

import {
  RapidRewardsNumberFormField,
  rapidRewardsNumberFormFieldPropTypes,
} from "../RapidRewardsNumberFormField";
import styles from "./PersonalInfoFormFields.module.scss";
import { ASSOCIATED_ADULT_SCHEMA_FIELD_NAME } from "./PersonalInfoFormFields.schema";

/**
 * PersonalInfoFormFields contains form input fields for first last and middle names,
 * suffix, date of birth, gender and rapid rewards number.
 */
export const PersonalInfoFormFields = (props) => {
  const {
    className,
    dateOfBirthFormFieldProps = {},
    genderFormFieldProps = {},
    lapChildAdults,
    nameFormFieldsProps = {},
    rapidRewardsNumberFormFieldProps = {},
  } = props;

  return (
    <>
      <NameFormFields {...nameFormFieldsProps} />
      <div className={classNames(styles.defaultLayout, className)}>
        <DateOfBirthFormField {...dateOfBirthFormFieldProps} />
        <GenderFormField {...genderFormFieldProps} />
        {lapChildAdults?.length ? renderAssociatedAdultField() : renderRapidRewardsNumberField()}
      </div>
    </>
  );

  function renderAssociatedAdultField() {
    return <SelectFormField {...getAssociatiedAdultFieldProps()} />;
  }

  function renderRapidRewardsNumberField() {
    return <RapidRewardsNumberFormField {...rapidRewardsNumberFormFieldProps} />;
  }

  function getAssociatiedAdultFieldProps() {
    const adultNamesKey =
      lapChildAdults?.map((adult) => adult.displayValue).join("-") || "no-adults";

    return {
      componentProps: {
        list: lapChildAdults,
      },
      key: `associated-adult-${adultNamesKey}`,
      label: i18n("PersonalInfoFormFields__ASSOCIATED_ADULT_LABEL"),
      name: ASSOCIATED_ADULT_SCHEMA_FIELD_NAME,
    };
  }
};

export const PersonalInfoFormFieldsPropTypes = {
  /** List of adults available for lap child association. */
  lapChildAdults: PropTypes.arrayOf(PropTypes.object),

  /** Class name for positioning the component. */
  className: PropTypes.string,

  /** Component props for DateOfBirthFormField component. */
  dateOfBirthFormFieldProps: PropTypes.shape(dateOfBirthFormFieldPropTypes),

  /** Component props for GenderFormField component. */
  genderFormFieldProps: PropTypes.shape(genderFormFieldPropTypes),

  /** Component props for NameFormFields component. */
  nameFormFieldsProps: PropTypes.shape(nameFormFieldsPropTypes),

  /** Component props for RapidRewardsNumberFormField component. */
  rapidRewardsNumberFormFieldProps: PropTypes.shape(rapidRewardsNumberFormFieldPropTypes),
};

PersonalInfoFormFields.propTypes = PersonalInfoFormFieldsPropTypes;
